import React from 'react';
import { Link } from 'react-router-dom';

const LockIcon = () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
        <rect x="5" y="11" width="14" height="9" rx="2" />
        <path d="M8 11V7a4 4 0 018 0v4" />
    </svg>
);

/**
 * Pre-match state: when it starts, what is already set up, and what still
 * needs a decision. Spectators only see the kick-off card.
 */
function MatchPreMatchPanel({
    kickoffText,
    autoStartNote,
    isParticipant = false,
    formationLabel,
    hasSavedLineup = false,
    tacticTitle,
    lineupHref,
    onChangeTactic,
    isLineupLockEnabled = false
}) {
    return (
        <>
            <div className="mx-card mx-ko" data-testid="match-kickoff-card">
                <div className="mx-ko__when">Kick-off</div>
                <div className="mx-ko__time">{kickoffText}</div>
                <div className="mx-ko__note">{autoStartNote}</div>
            </div>

            {isParticipant && (
                <div className="mx-card" data-testid="match-preparation-card">
                    <h5>Your preparation</h5>

                    <div className="mx-prep">
                        <span className="mx-prep__ico">XI</span>
                        <span className="mx-prep__main">
                            <span className="mx-prep__title">Starting lineup</span>
                            <span className="mx-prep__sub">
                                {hasSavedLineup
                                    ? `${formationLabel || 'Lineup'} saved`
                                    : 'No lineup saved yet'}
                            </span>
                        </span>
                        {lineupHref && (
                            <Link className="mx-prep__action" to={lineupHref}>
                                {hasSavedLineup ? 'Edit' : 'Set up'}
                            </Link>
                        )}
                    </div>

                    <div className="mx-prep">
                        <span className="mx-prep__ico">T</span>
                        <span className="mx-prep__main">
                            <span className="mx-prep__title">Tactic</span>
                            <span className="mx-prep__sub">{tacticTitle || 'Not Set'}</span>
                        </span>
                        <button type="button" className="mx-prep__action" onClick={onChangeTactic}>
                            Change
                        </button>
                    </div>

                    {isLineupLockEnabled && (
                        <div className="mx-lock-note">
                            <LockIcon />
                            <span>
                                Lineups lock <strong>15 minutes before kickoff</strong>. You can still make
                                live changes during the match.
                            </span>
                        </div>
                    )}
                </div>
            )}
        </>
    );
}

export default MatchPreMatchPanel;
